import script from "./Greeting.vue?vue&type=script&setup=true&lang=js"
export * from "./Greeting.vue?vue&type=script&setup=true&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=dbf91742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbf91742"]])

export default __exports__